import { ListItem, ListItemButton, ListItemText, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import {
  getNextScheduled,
  NOTIFICATION_LEFT_PADDING
} from 'components/navigation/Notifications/utils'
import { ScheduledScenarioDetails } from 'hooks/use-scenario-schedule-details'
import theme from 'theme'
import { ScheduledScenario } from 'types/schedules/scheduled-scenarios'

export const ScheduledScenarioListItem: React.FC<{
  schedule: ScheduledScenario
  scenario: ScheduledScenarioDetails
}> = ({ schedule, scenario, ...rest }) => {
  const { name, commandType } = scenario

  return (
    <ListItem
      data-test-notification-item
      data-test-scheduled-scenario
      disablePadding
      component="div"
      {...rest}
    >
      <ListItemButton
        dense
        component={Link}
        to={`/scenarios/detail/${schedule.scenario_id}`}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ pl: NOTIFICATION_LEFT_PADDING, width: '100%' }}
        >
          <GlyphIcon css={{ marginRight: theme.space[3] }}>
            <AttackTypeIcon icon={commandType} />
          </GlyphIcon>

          <ListItemText
            data-test-notification-text
            primary={name}
            secondary={
              <span data-test-schedule>
                {getNextScheduled(schedule.trigger)}
              </span>
            }
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
